import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { useSetRecoilState } from "recoil";
import { sectionsPermissionsAtom } from "stores";

const getSectionsPermissions = async () =>
  axios.get(Routes.GET_SECTIONS_PERMISSIONS);

export const useGetSectionsPermissions = () => {
  const setSectionsPermissions = useSetRecoilState(sectionsPermissionsAtom);

  return useQuery({
    queryKey: [Keys.GET_SECTIONS_PERMISSIONS_QRY],
    queryFn: getSectionsPermissions,
    onSuccess: (res) => setSectionsPermissions(res?.data?.sections),
    enabled: false,
  });
};
